let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jnX93")).then(() => parcelRequire('fhrt7'));